module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "oyster.79babe45.svg";